<template>
  <div id="landingDashboard">
    <div v-if="school.site_code !== null">
      <v-container fluid  class="margin-top-minus-24">
        <v-row class="header-container contentHeading">
          <v-col cols="12" style="align-self: center;">
            <span class="pl-3 display-1 white-color">{{school.site_name}}</span><br>
            <span class="pl-3 subtitle-1 white-color">School Code: {{school.site_code}}</span>
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid class="margin-top-minus-24 pt-6 contentSpacer">
          <v-row justify="space-between">
            <v-col :cols="6" class="pt-0">
                <v-container fluid class="pt-0 pl-0">
                  <v-row>
                    <v-col :cols="6" class="pr-0">
                      <Card
                        :title="school.site_enrolments"
                        backgroundColor="#041E42"
                        subTitle="FTE Students"
                        content="As of August 2020 Census. FTE = Full-Time Equivalence. An FTE is a measurement equal to one student enrolled full time for one academic year. Total FTE enrolment includes full time students plus the calculated equivalent of the part-time enrolments"
                      />
                    </v-col>
                    <v-col :cols="6" class="pr-0">
                      <Card
                        :title="deviceCount"
                        backgroundColor="#1D428A"
                        subTitle="Managed Devices"
                        content="“Managed” means machines that are connected to the network and run the Departments Standard Operating Environment (SOE) image. Currently, we are limited to obtaining accurate “managed” device data for Google, Microsoft and Apple devices (excluding iOS devices, e.g. iPads and iPhones)"
                      />
                    </v-col>
                    <v-col :cols="12" class="pr-0 pt-1">
                      <v-card>
                        <v-list>
                          <v-list-item class="pa-3">
                            <v-list-item-action class="mr-3 ml-1">
                              <v-icon class="school-icons">my_location</v-icon>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title class="school-data"><span
                                style="font-weight: bold;">{{ school.site_street }} {{ school.site_suburb }} {{ school.site_postcode }}</span></v-list-item-title>
                              <v-list-item-subtitle class="">Location</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-divider/>

                          <v-list-item class="pa-3">
                            <v-list-item-action class="mr-3 ml-1">
                              <v-icon class="school-icons">location_city</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title class="school-data"><span style="font-weight: bold;">{{ school.site_operational_directorate }}</span>
                              </v-list-item-title>
                              <v-list-item-subtitle class="">Operational Directorate</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-divider/>

                          <v-list-item class="pa-3 pb-0">
                            <v-list-item-action class="mr-3 ml-1">
                              <v-icon class="material-icons-outlined">school</v-icon>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title class="school-data"><span style="font-weight: bold;">{{ school.site_principal_network }}</span>
                              </v-list-item-title>
                              <v-list-item-subtitle class="">Principal Network</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
            </v-col>
            <v-col :cols="6" class="pt-3 pb-3">
              <v-card>
                <v-container fluid>
                  <v-row>
                    <v-col class="d-flex child-flex" cols="12">
                      <v-card flat tile class="d-flex justify-center">
                        <v-img
                          max-height="186"
                          max-width="178"
                          src="@/assets/about-ictplus.png"
                        >
                        </v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
                <v-card-title class="justify-center pl-10 pr-10">
                  <Markdown :code="content.title"/>
                </v-card-title>
                <v-card-text class="text--primary pl-10 pr-10">
                  <Markdown :code="content.description"/>
                </v-card-text>

                <v-layout justify-center>
                  <v-card-actions class="pb-10">
                    <v-btn class="brand-color text-none" href="/#/help-and-support" height="48px" width="221px">
                      <span>More about ICT PLUS</span>
                    </v-btn>
                  </v-card-actions>
                </v-layout>
              </v-card>
            </v-col>
          </v-row>
      </v-container>
    </div>
    <div class="contentSpacer" v-else>
      <EmptyState/>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapState, mapGetters} from "vuex";
    import Card from "../simpleComponents/Card";
    import Markdown from "../simpleComponents/Markdown";
    import EmptyState from "../simpleComponents/EmptyState";

    export default {
        name: "LandingDashboard",
        components: {
            Card,
            Markdown,
            EmptyState
        },
        data() {
            return {
                content:
                    {
                        "title": "#### About ICT PLUS",
                        "description":
                            "**ICT PLUS** ( **P**lanning, **L**eading, **U**tilisation, **S**trategy) is here to aid principals and school leaders in making data-informed decisions about their schools' use of technology. It is a tool built to provide greater insights by surfacing data from multiple existing datasets, in a single user-friendly portal, with the aim to save time and increase transparency." +
                            "<br><br>  " +
                            "Access to ICT PLUS is currently open to all school principals and field operations staff. Principals can delegate access to staff via AMU." +
                            "<br><br>  " +
                            "Stay informed and connect with other users in the [ICT PLUS Yammer group](https://www.yammer.com/det.nsw.edu.au/#/threads/inGroup?type=in_group&amp;feedId=8610013184).",
                    }
            }
        },
        methods: {
            ...mapActions(['fetchDeviceCount']),
        },
        mounted() {
            if (this.school.site_code) {
                this.fetchDeviceCount(this.school.site_code);
            }
        },
        computed: {
            ...mapGetters([
                "claims",
                "deviceCount",
                "devicesPerStudent",
            ]),
            ...mapState({
                school: s => s.school.selected,
            }),
        },
        watch: {
            school: function () {
                if (this.school.site_code) {
                    this.fetchDeviceCount(this.school.site_code);
                }
            },
        }
    }
</script>

<style scoped>

  #landingDashboard >>> .white-color {
    color: #FFFFFF;
  }

  #landingDashboard >>> .brand-color {
    color: #FFFFFF;
    background-color: #0E2D58;
  }

  #landingDashboard >>> .margin-top-minus-24 {
    margin-top: -24px !important;
  }

  #landingDashboard >>> .header-container {
    background-image: url(../../assets/doe-bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 120px;

    margin-left: -24px !important;
    margin-right: -24px !important
  }

  #landingDashboard >>> .theme--dark.v-expansion-panels .v-expansion-panel {
    background-color: #0E2D58 !important;
  }

  #landingDashboard >>> .theme--light.v-icon {
    color: #041E42 !important;
  }
</style>
